/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMmsiGet200ResponseRecordsInner
 */
export interface UserMmsiGet200ResponseRecordsInner {
    /**
     * 
     * @type {number}
     * @memberof UserMmsiGet200ResponseRecordsInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserMmsiGet200ResponseRecordsInner
     */
    name?: number;
}

/**
 * Check if a given object implements the UserMmsiGet200ResponseRecordsInner interface.
 */
export function instanceOfUserMmsiGet200ResponseRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserMmsiGet200ResponseRecordsInnerFromJSON(json: any): UserMmsiGet200ResponseRecordsInner {
    return UserMmsiGet200ResponseRecordsInnerFromJSONTyped(json, false);
}

export function UserMmsiGet200ResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMmsiGet200ResponseRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function UserMmsiGet200ResponseRecordsInnerToJSON(value?: UserMmsiGet200ResponseRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

